import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyBpWNRPTadYWz8vUeFRmRCRyu3zXn_xbpg',
  authDomain: 'emergencias-bariatricas.firebaseapp.com',
  databaseURL: 'https://emergencias-bariatricas.firebaseio.com',
  projectId: 'emergencias-bariatricas',
  storageBucket: 'emergencias-bariatricas.appspot.com',
  messagingSenderId: '511305661986',
  appId: '1:511305661986:web:66fc14bb889babc095147b',
  measurementId: 'G-MNB8Q8ZQCH',
};
// Get a Firestore instance
const app = firebase
  .initializeApp(firebaseConfig);
firebase.analytics();

const firestore = app.firestore();

firestore.enablePersistence();

export const db = firestore;
export const rdb = app.database();

export const storage = firebase.storage(app);

export const auth = app.auth();
